export const toBoolean = (value) => {
  if(value === null || value === "null") return null;
  if(value === true || value === "true" || value === 1 || value === "1") return true;
  if(value === false || value === "false" || value === 0 || value === "0") return false;
  throw new Error("Invalid boolean value");
}